module.exports = __webpack_public_path__ + "img/mb_banner.775891a5.png";